import { InjectionToken } from '@angular/core';
import type { LightGalleryConfig } from './media-viewer-light-gallery.types';

export const LIGHTGALLERY_CONFIG = new InjectionToken<LightGalleryConfig>(
  'LightGalleryConfig',
);
